var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { audioAlertManager } from './audioAlerts';
import { startTabAlert, stopTabAlert } from './alertNotification';
// ✅ Armazena IDs dos alertas já notificados (persistente entre atualizações)
var notifiedAlerts = new Set();
// ✅ Armazena alertas ativos (para limpar quando o problema for resolvido)
var activeAlerts = new Map();
// ✅ Limpa alertas antigos (chame ao visualizar ou após resolver)
export var clearNotifiedAlerts = function () {
    notifiedAlerts.clear();
    activeAlerts.clear();
    stopTabAlert();
    // console.log('✅ Cache de alertas notificados limpo');
};
// ✅ Remove um alerta específico quando o problema for resolvido
export var resolveAlert = function (alertId) {
    notifiedAlerts.delete(alertId);
    activeAlerts.delete(alertId);
    // console.log(`✅ Alerta resolvido: ${alertId}`);
};
// ✅ Verifica se um alerta ainda está ativo
var isAlertStillActive = function (alertId, currentAlerts) {
    return currentAlerts.some(function (alert) { return alert.id === alertId; });
};
// ✅ Limpa alertas resolvidos automaticamente
var cleanResolvedAlerts = function (currentAlerts) {
    var currentAlertIds = new Set(currentAlerts.map(function (a) { return a.id; }));
    // Remove alertas que não existem mais (problema resolvido)
    for (var _i = 0, notifiedAlerts_1 = notifiedAlerts; _i < notifiedAlerts_1.length; _i++) {
        var alertId = notifiedAlerts_1[_i];
        if (!currentAlertIds.has(alertId)) {
            // console.log(`✅ Alerta resolvido automaticamente: ${alertId}`);
            notifiedAlerts.delete(alertId);
            activeAlerts.delete(alertId);
        }
    }
};
// ✅ Notifica novos alertas (som + piscar aba)
var notifyNewAlerts = function (newAlerts) { return __awaiter(void 0, void 0, void 0, function () {
    var alertsToNotify, error_1, criticalCount, warningCount, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (newAlerts.length === 0)
                    return [2 /*return*/];
                alertsToNotify = newAlerts.filter(function (alert) { return !notifiedAlerts.has(alert.id); });
                if (alertsToNotify.length === 0) {
                    // console.log('ℹ️ Todos os alertas já foram notificados anteriormente');
                    return [2 /*return*/];
                }
                // ✅ Marca alertas como notificados
                alertsToNotify.forEach(function (alert) {
                    notifiedAlerts.add(alert.id);
                    activeAlerts.set(alert.id, alert);
                });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, audioAlertManager.playAlert()];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.error('❌ Erro ao tocar alerta sonoro:', error_1);
                return [3 /*break*/, 4];
            case 4:
                // ✅ Pisca a aba (apenas se a página não estiver em foco)
                if (document.hidden) {
                    criticalCount = alertsToNotify.filter(function (a) { return a.severity === 'critical'; }).length;
                    warningCount = alertsToNotify.filter(function (a) { return a.severity === 'warning'; }).length;
                    message = '🚨 NOVO ALERTA!';
                    if (criticalCount > 0 && warningCount > 0) {
                        message = "\uD83D\uDEA8 ".concat(criticalCount, " CR\u00CDTICO(S) + ").concat(warningCount, " AVISO(S)");
                    }
                    else if (criticalCount > 0) {
                        message = "\uD83D\uDEA8 ".concat(criticalCount, " ALERTA").concat(criticalCount > 1 ? 'S' : '', " CR\u00CDTICO").concat(criticalCount > 1 ? 'S' : '', "!");
                    }
                    else {
                        message = "\u26A0\uFE0F ".concat(warningCount, " AVISO").concat(warningCount > 1 ? 'S' : '');
                    }
                    startTabAlert(message);
                }
                // console.log(`🔔 ${alertsToNotify.length} novo(s) alerta(s) notificado(s):`);
                alertsToNotify.forEach(function (alert) {
                    // console.log(`  - ${alert.severity.toUpperCase()}: ${alert.message}`);
                });
                return [2 /*return*/];
        }
    });
}); };
// ✅ Detectar alertas comparando estados anterior e atual
export var detectAlerts = function (previousClients, currentClients) { return __awaiter(void 0, void 0, Promise, function () {
    var alerts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                alerts = [];
                currentClients.forEach(function (currentClient) {
                    var _a, _b;
                    var previousClient = previousClients.find(function (c) { return c.id === currentClient.id; });
                    if (!previousClient)
                        return;
                    // ✅ Verificar Google Ads
                    if (currentClient.google && previousClient.google) {
                        // Conta parou
                        var wasAccountActive = !previousClient.google.account_stopped;
                        var isAccountActive = !currentClient.google.account_stopped;
                        if (!isAccountActive) { // ✅ Alerta existe
                            var alertId = "google-account-".concat(currentClient.id);
                            alerts.push({
                                id: alertId,
                                clientId: currentClient.id,
                                clientName: currentClient.name,
                                platform: 'google',
                                type: 'account_stopped',
                                message: "Conta Google Ads parou de veicular",
                                severity: 'critical'
                            });
                        }
                        // Saldo zerado
                        if (currentClient.google.balance !== undefined && currentClient.google.balance <= 0) {
                            var alertId = "google-balance-zero-".concat(currentClient.id);
                            alerts.push({
                                id: alertId,
                                clientId: currentClient.id,
                                clientName: currentClient.name,
                                platform: 'google',
                                type: 'balance_zero',
                                message: "Saldo Google Ads zerou",
                                severity: 'critical'
                            });
                        }
                        // Saldo baixo (< R$ 50)
                        if (currentClient.google.balance !== undefined && currentClient.google.balance > 0 && currentClient.google.balance < 50) {
                            var alertId = "google-balance-low-".concat(currentClient.id);
                            alerts.push({
                                id: alertId,
                                clientId: currentClient.id,
                                clientName: currentClient.name,
                                platform: 'google',
                                type: 'balance_low',
                                message: "Saldo Google Ads est\u00E1 baixo (R$ ".concat(currentClient.google.balance.toFixed(2), ")"),
                                severity: 'warning'
                            });
                        }
                        // Campanhas pararam
                        (_a = currentClient.google.campaigns) === null || _a === void 0 ? void 0 : _a.forEach(function (currentCampaign) {
                            var isCampaignActive = !currentCampaign.campaign_stopped;
                            if (!isCampaignActive) { // ✅ Alerta existe
                                var alertId = "google-campaign-".concat(currentCampaign.campaign_id);
                                alerts.push({
                                    id: alertId,
                                    clientId: currentClient.id,
                                    clientName: currentClient.name,
                                    platform: 'google',
                                    type: 'campaign_stopped',
                                    message: "Campanha \"".concat(currentCampaign.campaign_name, "\" parou"),
                                    severity: 'critical',
                                    campaignName: currentCampaign.campaign_name,
                                    campaignId: currentCampaign.campaign_id
                                });
                            }
                        });
                    }
                    // ✅ Verificar Facebook Ads
                    if (currentClient.facebook && previousClient.facebook) {
                        var isAccountActive = !currentClient.facebook.account_stopped;
                        if (!isAccountActive) { // ✅ Alerta existe
                            var alertId = "facebook-account-".concat(currentClient.id);
                            alerts.push({
                                id: alertId,
                                clientId: currentClient.id,
                                clientName: currentClient.name,
                                platform: 'facebook',
                                type: 'account_stopped',
                                message: "Conta Facebook Ads parou de veicular",
                                severity: 'critical'
                            });
                        }
                        if (currentClient.facebook.balance !== undefined && currentClient.facebook.balance <= 0) {
                            var alertId = "facebook-balance-zero-".concat(currentClient.id);
                            alerts.push({
                                id: alertId,
                                clientId: currentClient.id,
                                clientName: currentClient.name,
                                platform: 'facebook',
                                type: 'balance_zero',
                                message: "Saldo Facebook Ads zerou",
                                severity: 'critical'
                            });
                        }
                        if (currentClient.facebook.balance !== undefined && currentClient.facebook.balance > 0 && currentClient.facebook.balance < 50) {
                            var alertId = "facebook-balance-low-".concat(currentClient.id);
                            alerts.push({
                                id: alertId,
                                clientId: currentClient.id,
                                clientName: currentClient.name,
                                platform: 'facebook',
                                type: 'balance_low',
                                message: "Saldo Facebook Ads est\u00E1 baixo (R$ ".concat(currentClient.facebook.balance.toFixed(2), ")"),
                                severity: 'warning'
                            });
                        }
                        (_b = currentClient.facebook.campaigns) === null || _b === void 0 ? void 0 : _b.forEach(function (currentCampaign) {
                            var isCampaignActive = !currentCampaign.campaign_stopped;
                            if (!isCampaignActive) { // ✅ Alerta existe
                                var alertId = "facebook-campaign-".concat(currentCampaign.campaign_id);
                                alerts.push({
                                    id: alertId,
                                    clientId: currentClient.id,
                                    clientName: currentClient.name,
                                    platform: 'facebook',
                                    type: 'campaign_stopped',
                                    message: "Campanha \"".concat(currentCampaign.campaign_name, "\" parou"),
                                    severity: 'critical',
                                    campaignName: currentCampaign.campaign_name,
                                    campaignId: currentCampaign.campaign_id
                                });
                            }
                        });
                    }
                    // ✅ Instagram (similar ao Facebook)
                    if (currentClient.instagram && previousClient.instagram) {
                        var isAccountActive = !currentClient.instagram.account_stopped;
                        if (!isAccountActive) { // ✅ Alerta existe
                            var alertId = "instagram-account-".concat(currentClient.id);
                            alerts.push({
                                id: alertId,
                                clientId: currentClient.id,
                                clientName: currentClient.name,
                                platform: 'instagram',
                                type: 'account_stopped',
                                message: "Conta Instagram parou de veicular",
                                severity: 'critical'
                            });
                        }
                    }
                });
                // ✅ Limpa alertas que foram resolvidos
                cleanResolvedAlerts(alerts);
                if (!(alerts.length > 0)) return [3 /*break*/, 2];
                return [4 /*yield*/, notifyNewAlerts(alerts)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, alerts];
        }
    });
}); };
// ✅ Retorna alertas ativos (para exibir no modal)
export var getActiveAlerts = function () {
    return Array.from(activeAlerts.values());
};
